import { useMemo } from 'react'
import { ComponentWithPermissions } from '../../../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import ProductCategories from '../../../../../../../../../../baseComponents/Product/ProductCategories'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormElement, FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { personalizedValueOrDefaultValue } from '../../../../../../../../../../specificComponents/Product/ProductLayout/RightSide/DefaultMainRightProductLayout/functions'
import { ProductExtendedTyShort, AddLangIdProductModelType } from '../../../../../../../../../../specificComponents/Product/types'
import { addDictionaryExtraLine } from '../../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllGroupVats, getAllBrands, getActiveLangs, getAllCollections } from '../../../../../../../../../../utils/reducers/getters'

interface MainRightServiceLayoutProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    changeLang?: (lang: string) => void
    selectedLang?: string
}

const MainRightServiceLayout: React.FC<MainRightServiceLayoutProps> = ({ basicData, userPermissions, changeLang, selectedLang }) => {
    const { t } = useTwinTranslation()
    const groupVats = getAllGroupVats()
    const brands = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getAllBrands()))), [])
    const collections = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getAllCollections()))), [])
    const haveUpdatePermission = permissionCheck(userPermissions, 'update')
    const extraRightFields: FormElement<keyof AddLangIdProductModelType>[] = []
    if (basicData.reference) {
        extraRightFields.push({
            label: t('reference', 'Referencia'),
            name: 'reference',
            component: 'InputWithLabelMargin'
        })
    }
    if (basicData.unique_number) {
        extraRightFields.push({
            label: t('uniqueNumber', 'Número único'),
            name: 'unique_number',
            component: 'InputWithLabelMargin'
        })
    }

    const rightFields: FormRender<AddLangIdProductModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                ...extraRightFields,
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {}
                },
                {
                    name: 'BrandId',
                    label: t('brand', 'Marca'),
                    component: 'CustomSelectWithSearchBar',
                    items: brands,
                    sortItems: true
                },
                {
                    name: 'CollectionId',
                    label: t('collection', 'Colección'),
                    component: 'CustomSelectWithSearchBar',
                    items: collections,
                    sortItems: true
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        },
    ]
    const parsedRightFields = personalizedValueOrDefaultValue(rightFields, userPermissions, basicData)
    return (
        <div className='flex flex-col w-1/4 notFlexAutoFormRender product_container_right'>
            <FormRenderer sections={parsedRightFields} antiUnsaveTrigger={true} />
            <span className='regular16 mt-25 block'>
                <TwinTrans transKey='categories'>Categorías</TwinTrans>
            </span>
            <ProductCategories selectedCategories={basicData?.parsedCategories || []} productType={6} categoryProducts={basicData.CategoriesProducts} readOnly={!haveUpdatePermission} />
        </div>
    )
}

export default MainRightServiceLayout